import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import { green, teal, lime, lightBlue, lightGreen } from "@mui/material/colors";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// import Avatar from "@mui/material/Avatar";
import { Badge } from "@mui/material";
import { matchPath, useLocation } from "react-router-dom";




/**
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {number} props.value
 * @param {number} props.index
 * @returns {JSX.Element}
 */
export function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    // right: -4,
    // top: 0,
    // border: `2px solid ${theme.palette.background.paper}`,
    // padding: "0 4px",
    // fontSize: "15px",
  },
}));

export function TabIcon(props) {
  const { children, icon, label, badgeContent, color, iconColor } = props;
  return (
    <Grid container direction="row" spacing={1} sx={{ paddingTop: '.6em', paddingBottom: ".4em",  paddingLeft: '.8em', paddingRight: '.8em'}}>
      <Grid item xs={2}>
        
          {/* <Avatar sx={{ bgcolor: iconColor }} variant="rounded"> */}
           {icon}
          {/* </Avatar> */}
      </Grid>
      <Grid item xs={1}></Grid>
      <Grid item xs={9} sx={{ textAlign: "left"}}>
        <Typography   variant="subtitle2"> {label}</Typography>
      </Grid>
    </Grid>
  );
}
export const AntTabs = styled((props) => <Tabs {...props}>{props.children}</Tabs>)({
  "& .MuiTabs-indicator": {
    display: "none",
    justifyContent: "center",
  },
});

export const AntTab = styled((props) => <Tab {...props}>{props.children}</Tab>)(({ theme }) => ({
  textTransform: "none",
  minWidth: 0,
  [theme.breakpoints.up("sm")]: {
    minWidth: 0,
  },
  padding: '1.5em',
  fontWeight: theme.typography.fontWeightRegular,
  color: "rgba(0, 0, 0, 0.70)",
  fontFamily: [
    "quicksand",
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    color: "#000000",
    backgroundColor: '#8080801c',
    opacity: .8,
  },
  "&.Mui-selected": {
    backgroundColor: '#8080801c',
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
const fabStyle = {
  position: "absolute",
  bottom: 40,
  right: 40,
};
const fabLightBlueStyle = {
  color: "common.white",
  bgcolor: lightBlue[500],
  "&:hover": {
    bgcolor: lightBlue[600],
  },
};
const fabTealStyle = {
  color: "common.white",
  bgcolor: teal[500],
  "&:hover": {
    bgcolor: teal[600],
  },
};
const fabLightGreenStyle = {
  color: "common.white",
  bgcolor: lightGreen[500],
  "&:hover": {
    bgcolor: lightGreen[600],
  },
};
const fabGreenStyle = {
  color: "common.white",
  bgcolor: green[500],
  "&:hover": {
    bgcolor: green[600],
  },
};
const fabLimeStyle = {
  color: "common.black",
  bgcolor: lime[700],
  "&:hover": {
    bgcolor: lime[800],
  },
};
export function useRouteMatch(patterns) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

